export const DEFAULT_PIN_COUNT = 200;
export const DEFAULT_CLUSTER_COUNT = 30;

export const PIN_SIZE = 44 * 44;
export const CLUSTER_SIZE = 100 * 100;


// WEBPACK FOOTER //
// ./shared_critical/constants/pins.js